import React, { FC } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

import { scale } from '@components/frame';
import { TIME_CATEGORY_BLOCK_HEIGHT } from '@v2/context/ProductionBatch/tile/constants';
import { SmallLoading } from '@components/loading';
import { ProductionBatchStatistics } from '@interfaces/search';
import { ProductiveTimeBlock } from '@components/machines/components/detailsComponents/activeMachine/interfaces';
import { TimeCategory } from '@interfaces/base';
import { InlineErrorBoundary, InlineErrorFallbackSize } from '@v2/components/errorBoundary';

interface TimeCategoryBlockProps {
  batchIsRunning: boolean;
  batchStatisticsLoaded: boolean;
  productiveTimeBlockComponents: ProductiveTimeBlock[];
  containerStyles?: StyleProp<ViewStyle>;
}

const TimeCategoryBlock: FC<TimeCategoryBlockProps> = ({ batchStatisticsLoaded, batchIsRunning, productiveTimeBlockComponents, containerStyles }) => {
  return (
    <View
      style={[
        {
          flex: 1,
          minHeight: scale(TIME_CATEGORY_BLOCK_HEIGHT),
          height: scale(TIME_CATEGORY_BLOCK_HEIGHT),
          justifyContent: 'center',
          position: 'relative',
        },
        containerStyles,
      ]}
    >
      <InlineErrorBoundary screenName="BatchTileTimeCategoryBlock" size={InlineErrorFallbackSize.Micro} resetKey={batchStatisticsLoaded ? 'loaded' : 'loading'}>
        {batchIsRunning && !batchStatisticsLoaded ? (
          <View style={{ flex: 1, justifyContent: 'center' }}>
            <SmallLoading />
          </View>
        ) : (
          <>
            {productiveTimeBlockComponents.map((d) => {
              const isPaidLine = d.name === TimeCategory.PAID;
              return <View key={d.key} style={[isPaidLine && !batchStatisticsLoaded && { opacity: 0 }, { flex: 1 }]}>{d.Component()}</View>;

              // return isPaidLine && true ? (
              //   <View key={d.key} style={{ width: '100%', alignItems: 'center', flex: 1, position: 'absolute', bottom: 0 }}>
              //     <SmallLoading />
              //   </View>
              // ) : (
              //   <React.Fragment key={d.key}>{d.Component()}</React.Fragment>
              // );
            })}
          </>
        )}
      </InlineErrorBoundary>
    </View>
  );
};

export { TimeCategoryBlock };
